<template>
  <div class="content if-profile report-tab spf-finance-ratio">
    <SPIFReportHeader :headerData="this.headerData"/>
    <div class="md-layout if-profile-body spf-ratio-lyout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0 mt-4">
          <h1 class="section_header">Financial Ratios</h1>
          <div class="md-toolbar-row fundamentals_wpr p-0">
            <div class="md-card-nav-tabs">
              <div class="md-toolbar-row fundamentals_area p-0 m-0">
                <nav-tabs-card no-label md-elevation="0">
                  <template slot="content">
                    <md-tabs md-alignment="left" class="p-0">
                      <md-tab
                        id="tab-cash"
                        md-label="Cash flow-Solvency"
                        md-icon="money"
                        class="p-0"
                      >
                        <div class="md-layout">
                          
                          <SPIFCashRatiosVariance/>
                        </div>
                      </md-tab>
                      <md-tab
                        id="tab-profitability"
                        md-label="Profitability"
                        md-icon="payments"
                        class="p-0"
                      >
                        <div class="md-layout">
                          <SPIFProfitabilityVariance/>
                        </div>
                      </md-tab>
                      <md-tab
                        id="tab-efficiency"
                        md-label="Efficiency"
                        md-icon="pie_chart"
                        class="p-0"
                      >
                        <div class="md-layout">
                          <SPIFEfficiencyVariance/>
                        </div>
                      </md-tab>
                      
                    </md-tabs>
                  </template>
                </nav-tabs-card>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard } from '@/components';
import formatData from '@/mixins/format-data';
import SPIFReportHeader from './_partials/SPIFHeader.vue';
import SPIFCashRatiosVariance from './SPIFRatios/SPIFCashRatiosVariance.vue';
import SPIFProfitabilityVariance from './SPIFRatios/SPIFProfitabilityVariance.vue';
import SPIFEfficiencyVariance from './SPIFRatios/SPIFEfficiencyVariance.vue';

export default {
  components: {
    SPIFReportHeader,
    NavTabsCard,
    SPIFCashRatiosVariance,
    SPIFProfitabilityVariance,
    SPIFEfficiencyVariance,
  },
  mixins: [formatData],
  props: ['headerData'],
};
</script>